import SliderZoomView from 'echarts/lib/component/dataZoom/SliderZoomView';
import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { DvSliderDataZoomModel } from './type';
import { isValidNumericValue } from './util';

function isDvHandleOffsetValid(dvHandleOffset: [number, number]) {
  return dvHandleOffset.every(offset => isValidNumericValue(offset));
}

function $getViewExtent(size: [number, number], dvHandleOffset?: [number, number]) {
  let extent = [0, size[0]];
  if (dvHandleOffset && isDvHandleOffsetValid(dvHandleOffset)) {
    extent = extent.map((minMax, index) => minMax + dvHandleOffset[index]);
  }
  return extent;
}

// @ts-ignore
SliderZoomView.prototype._getViewExtent = function getViewExtent() {
  // @ts-ignore
  const size = this._size as [number, number];
  const dvHandleOffset = (this.dataZoomModel as DvSliderDataZoomModel).get('dvHandleOffset');
  return $getViewExtent(size, dvHandleOffset);
};

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {});
}
